import { AnyAction } from '@reduxjs/toolkit';
import { FetchAuditLogRoutine } from '../redux-routines';
import { IAuditListState } from '../interfaces';

export const initialState: IAuditListState = {
  data: [],
  isFetching: false,
  error: null,
};

export const auditListReducer = (
  state: IAuditListState = initialState,
  action: AnyAction,
): IAuditListState => {
  switch (action.type) {
    case FetchAuditLogRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
        error: null,
      };
    case FetchAuditLogRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case FetchAuditLogRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
